import React from 'react';
import { Box, Typography, Button, Paper } from '@material-ui/core';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        
        // Log detalhado do erro no console para debug
        console.group(`🚨 Error Boundary capturou erro`);
        console.error('Erro:', error);
        console.error('Stack:', error.stack);
        console.error('Component Stack:', errorInfo.componentStack);
        console.error('Props:', this.props);
        console.groupEnd();
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <Box
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: '100vh',
                        padding: '20px',
                        backgroundColor: '#f5f5f5'
                    }}
                >
                    <Paper
                        elevation={3}
                        style={{
                            padding: '40px',
                            textAlign: 'center',
                            maxWidth: '600px',
                            width: '100%'
                        }}
                    >
                        <Typography
                            variant="h4"
                            component="h1"
                            style={{
                                marginBottom: '20px',
                                color: '#d32f2f'
                            }}
                        >
                            Ops! Algo deu errado
                        </Typography>
                        
                        <Typography
                            variant="body1"
                            style={{
                                marginBottom: '30px',
                                color: '#666'
                            }}
                        >
                            Ocorreu um erro inesperado. Nossa equipe foi notificada automaticamente.
                        </Typography>

                                                <Typography
                            variant="body2"
                            style={{
                                color: '#666',
                                marginBottom: '30px'
                            }}
                        >
                            Algo deu errado. Por favor, recarregue a página ou entre em contato com o suporte.
                        </Typography>

                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={this.handleReload}
                            style={{
                                fontSize: '1.2rem',
                                padding: '12px 30px'
                            }}
                        >
                            Recarregar Aplicação
                        </Button>

                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <Box
                                style={{
                                    marginTop: '30px',
                                    textAlign: 'left',
                                    backgroundColor: '#f8f8f8',
                                    padding: '20px',
                                    borderRadius: '4px',
                                    overflow: 'auto'
                                }}
                            >
                                <Typography variant="h6" style={{ marginBottom: '10px' }}>
                                    Detalhes do Erro (Desenvolvimento):
                                </Typography>
                                <Typography
                                    variant="body2"
                                    component="pre"
                                    style={{
                                        fontFamily: 'monospace',
                                        fontSize: '12px',
                                        whiteSpace: 'pre-wrap',
                                        wordBreak: 'break-word'
                                    }}
                                >
                                    {this.state.error.toString()}
                                    {this.state.errorInfo.componentStack}
                                </Typography>
                            </Box>
                        )}
                    </Paper>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
